!function (e, t) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = t();else if ("function" == typeof define && define.amd) define([], t);else {
    var n = t();

    for (var o in n) {
      ("object" == typeof exports ? exports : e)[o] = n[o];
    }
  }
}(window, function () {
  return function (e) {
    var t = {};

    function n(o) {
      if (t[o]) return t[o].exports;
      var r = t[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return e[o].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, o) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: o
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var o = Object.create(null);
      if (n.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var r in e) {
        n.d(o, r, function (t) {
          return e[t];
        }.bind(null, r));
      }
      return o;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 6);
  }([function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AvoInspector = void 0;

    var o = n(2),
        r = n(3),
        s = n(4),
        i = n(7),
        a = n(8),
        c = n(10),
        u = n(11),
        l = n(5),
        p = n(12).version,
        v = function () {
      function e(t) {
        var n = this;
        if (l.isValueEmpty(t.env) ? (this.environment = o.AvoInspectorEnv.Dev, console.warn("[Avo Inspector] No environment provided. Defaulting to dev.")) : -1 === Object.values(o.AvoInspectorEnv).indexOf(t.env) ? (this.environment = o.AvoInspectorEnv.Dev, console.warn("[Avo Inspector] Unsupported environment provided. Defaulting to dev. Supported environments - Dev, Staging, Prod.")) : this.environment = t.env, l.isValueEmpty(t.apiKey)) throw new Error("[Avo Inspector] No API key provided. Inspector can't operate without API key.");
        if (this.apiKey = t.apiKey, l.isValueEmpty(t.version)) throw new Error("[Avo Inspector] No version provided. Many features of Inspector rely on versioning. Please provide comparable string version, i.e. integer or semantic.");
        this.version = t.version, this.environment === o.AvoInspectorEnv.Dev ? (e._batchSize = 1, e._shouldLog = !0) : (e._batchSize = 30, e._batchFlushSeconds = 30, e._shouldLog = !1), e.avoStorage = new c.AvoStorage(e._shouldLog, null != t.suffix ? t.suffix : "");
        var r = new a.AvoNetworkCallsHandler(this.apiKey, this.environment.toString(), t.appName || "", this.version, p);
        this.avoBatcher = new i.AvoBatcher(r), this.sessionTracker = new s.AvoSessionTracker(this.avoBatcher), this.avoDeduplicator = new u.AvoDeduplicator();

        try {
          "undefined" != typeof window && window.addEventListener("load", function () {
            n.sessionTracker.startOrProlongSession(Date.now());
          }, !1);
        } catch (e) {
          console.error("Avo Inspector: something went wrong. Please report to support@avo.app.", e);
        }
      }

      return Object.defineProperty(e, "batchSize", {
        get: function get() {
          return this._batchSize;
        },
        set: function set(e) {
          this._batchSize = e < 1 ? 1 : e;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e, "batchFlushSeconds", {
        get: function get() {
          return this._batchFlushSeconds;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e, "shouldLog", {
        get: function get() {
          return this._shouldLog;
        },
        set: function set(e) {
          this._shouldLog = e;
        },
        enumerable: !1,
        configurable: !0
      }), e.prototype.trackSchemaFromEvent = function (t, n) {
        try {
          if (this.avoDeduplicator.shouldRegisterEvent(t, n, !1)) {
            e.shouldLog && console.log("Avo Inspector: supplied event " + t + " with params " + JSON.stringify(n));
            var o = this.extractSchema(n, !1);
            return this.trackSchemaInternal(t, o, null, null), o;
          }

          return e.shouldLog && console.log("Avo Inspector: Deduplicated event: " + t), [];
        } catch (e) {
          return console.error("Avo Inspector: something went wrong. Please report to support@avo.app.", e), [];
        }
      }, e.prototype._avoFunctionTrackSchemaFromEvent = function (t, n, o, r) {
        try {
          if (this.avoDeduplicator.shouldRegisterEvent(t, n, !0)) {
            e.shouldLog && console.log("Avo Inspector: supplied event " + t + " with params " + JSON.stringify(n));
            var s = this.extractSchema(n, !1);
            return this.trackSchemaInternal(t, s, o, r), s;
          }

          return e.shouldLog && console.log("Avo Inspector: Deduplicated event: " + t), [];
        } catch (e) {
          return console.error("Avo Inspector: something went wrong. Please report to support@avo.app.", e), [];
        }
      }, e.prototype.trackSchema = function (t, n) {
        try {
          this.avoDeduplicator.shouldRegisterSchemaFromManually(t, n) ? (e.shouldLog && console.log("Avo Inspector: supplied event " + t + " with schema " + JSON.stringify(n)), this.trackSchemaInternal(t, n, null, null)) : e.shouldLog && console.log("Avo Inspector: Deduplicated event: " + t);
        } catch (e) {
          console.error("Avo Inspector: something went wrong. Please report to support@avo.app.", e);
        }
      }, e.prototype.trackSchemaInternal = function (e, t, n, o) {
        try {
          this.sessionTracker.startOrProlongSession(Date.now()), this.avoBatcher.handleTrackSchema(e, t, n, o);
        } catch (e) {
          console.error("Avo Inspector: something went wrong. Please report to support@avo.app.", e);
        }
      }, e.prototype.enableLogging = function (t) {
        e._shouldLog = t;
      }, e.prototype.extractSchema = function (t, n) {
        void 0 === n && (n = !0);

        try {
          return this.sessionTracker.startOrProlongSession(Date.now()), this.avoDeduplicator.hasSeenEventParams(t, !0) && n && e.shouldLog && console.warn("Avo Inspector: WARNING! You are trying to extract schema shape that was just reported by your Avo functions. This is an indicator of duplicate inspector reporting. Please reach out to support@avo.app for advice if you are not sure how to handle this."), e.shouldLog && console.log("Avo Inspector: extracting schema from " + JSON.stringify(t)), r.AvoSchemaParser.extractSchema(t);
        } catch (e) {
          return console.error("Avo Inspector: something went wrong. Please report to support@avo.app.", e), [];
        }
      }, e.prototype.setBatchSize = function (t) {
        e._batchSize = t;
      }, e.prototype.setBatchFlushSeconds = function (t) {
        e._batchFlushSeconds = t;
      }, e._batchSize = 30, e._batchFlushSeconds = 30, e._shouldLog = !1, e;
    }();

    t.AvoInspector = v;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var o = function () {
      function e() {}

      return e.newGuid = function () {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (e) {
          var t = 16 * Math.random() | 0;
          return ("x" == e ? t : 3 & t | 8).toString(16);
        });
      }, e;
    }();

    t.default = o;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AvoInspectorEnv = void 0, t.AvoInspectorEnv = {
      Prod: "prod",
      Dev: "dev",
      Staging: "staging"
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AvoSchemaParser = void 0;

    var o = function o(e) {
      return "[object Array]" === Object.prototype.toString.call(e);
    },
        r = function () {
      function e() {}

      return e.extractSchema = function (e) {
        var t = this;
        if (null == e) return [];

        var n = function n(e) {
          if (o(e)) {
            var r = e.map(function (e) {
              return n(e);
            });
            return t.removeDuplicates(r);
          }

          if ("object" == typeof e) {
            var s = [];

            for (var i in e) {
              if (e.hasOwnProperty(i)) {
                var a = e[i],
                    c = {
                  propertyName: i,
                  propertyType: t.getPropValueType(a)
                };
                "object" == typeof a && null != a && (c.children = n(a)), s.push(c);
              }
            }

            return s;
          }

          return t.getPropValueType(e);
        };

        return n(e);
      }, e.removeDuplicates = function (e) {
        var t = {
          boolean: {},
          number: {},
          string: {}
        },
            n = [];
        return e.filter(function (e) {
          var o = typeof e;
          return o in t ? !t[o].hasOwnProperty(e) && (t[o][e] = !0) : !(n.indexOf(e) >= 0) && n.push(e);
        });
      }, e.getPropValueType = function (e) {
        var t = typeof e;
        return null == e ? "null" : "string" === t ? "string" : "number" === t || "bigint" === t ? (e + "").indexOf(".") >= 0 ? "float" : "int" : "boolean" === t ? "boolean" : "object" === t ? o(e) ? "list" : "object" : "unknown";
      }, e;
    }();

    t.AvoSchemaParser = r;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AvoSessionTracker = void 0;

    var o = n(1),
        r = n(0),
        s = function () {
      function e(e) {
        this._lastSessionTimestamp = null, this._sessionLengthMillis = 3e5, this.avoBatcher = e;
      }

      return Object.defineProperty(e, "sessionId", {
        get: function get() {
          if (null === e._sessionId) {
            if (!r.AvoInspector.avoStorage.isInitialized()) return "unknown";
            var t = null;

            try {
              t = r.AvoInspector.avoStorage.getItem(e.idCacheKey);
            } catch (e) {
              console.error("Avo Inspector: something went wrong. Please report to support@avo.app.", e);
            }

            e._sessionId = null == t ? this.updateSessionId() : t;
          }

          return e._sessionId;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "lastSessionTimestamp", {
        get: function get() {
          if (null === this._lastSessionTimestamp || 0 === this._lastSessionTimestamp) {
            var t = r.AvoInspector.avoStorage.getItem(e.lastSessionTimestampKey);
            null != t ? (this._lastSessionTimestamp = t, isNaN(this._lastSessionTimestamp) && (this._lastSessionTimestamp = 0)) : this._lastSessionTimestamp = 0;
          }

          return this._lastSessionTimestamp;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "sessionLengthMillis", {
        get: function get() {
          return this._sessionLengthMillis;
        },
        enumerable: !1,
        configurable: !0
      }), e.prototype.startOrProlongSession = function (t) {
        var n = this;
        r.AvoInspector.avoStorage.runAfterInit(function () {
          t - n.lastSessionTimestamp > n._sessionLengthMillis && (e.updateSessionId(), n.avoBatcher.handleSessionStarted()), n._lastSessionTimestamp = t, r.AvoInspector.avoStorage.setItem(e.lastSessionTimestampKey, n._lastSessionTimestamp);
        });
      }, e.updateSessionId = function () {
        e._sessionId = o.default.newGuid();

        try {
          r.AvoInspector.avoStorage.setItem(e.idCacheKey, e.sessionId);
        } catch (e) {
          console.error("Avo Inspector: something went wrong. Please report to support@avo.app.", e);
        }

        return e._sessionId;
      }, Object.defineProperty(e, "lastSessionTimestampKey", {
        get: function get() {
          return "AvoInspectorSessionTimestamp";
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e, "idCacheKey", {
        get: function get() {
          return "AvoInspectorSessionId";
        },
        enumerable: !1,
        configurable: !0
      }), e._sessionId = null, e;
    }();

    t.AvoSessionTracker = s;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.deepEquals = t.isValueEmpty = void 0;
    t.isValueEmpty = function (e) {
      return null == e || 0 == e.trim().length;
    }, t.deepEquals = function e(t, n) {
      if (t === n) return !0;
      if (!(t instanceof Object && n instanceof Object)) return !1;
      if (t.constructor !== n.constructor) return !1;

      for (var o in t) {
        if (t.hasOwnProperty(o)) {
          if (!n.hasOwnProperty(o)) return !1;

          if (t[o] !== n[o]) {
            if ("object" != typeof t[o]) return !1;
            if (!e(t[o], n[o])) return !1;
          }
        }
      }

      for (o in n) {
        if (n.hasOwnProperty(o) && !t.hasOwnProperty(o)) return !1;
      }

      return !0;
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AvoInspectorEnv = t.AvoInspector = void 0;
    var o = n(0);
    Object.defineProperty(t, "AvoInspector", {
      enumerable: !0,
      get: function get() {
        return o.AvoInspector;
      }
    });
    var r = n(2);
    Object.defineProperty(t, "AvoInspectorEnv", {
      enumerable: !0,
      get: function get() {
        return r.AvoInspectorEnv;
      }
    });
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AvoBatcher = void 0;

    var o = n(0),
        r = function () {
      function e(t) {
        var n = this;
        this.events = [], this.networkCallsHandler = t, this.batchFlushAttemptTimestamp = Date.now(), o.AvoInspector.avoStorage.getItemAsync(e.cacheKey).then(function (e) {
          if (null !== e) {
            var t = e.filter(function (e) {
              return null !== e;
            });
            n.events = n.events.concat(t), n.checkIfBatchNeedsToBeSent();
          }
        });
      }

      return e.prototype.handleSessionStarted = function () {
        this.events.push(this.networkCallsHandler.bodyForSessionStartedCall()), this.saveEvents(), this.checkIfBatchNeedsToBeSent();
      }, e.prototype.handleTrackSchema = function (e, t, n, r) {
        this.events.push(this.networkCallsHandler.bodyForEventSchemaCall(e, t, n, r)), this.saveEvents(), o.AvoInspector.shouldLog && console.log("Avo Inspector: saved event " + e + " with schema " + JSON.stringify(t)), this.checkIfBatchNeedsToBeSent();
      }, e.prototype.checkIfBatchNeedsToBeSent = function () {
        var e = this.events.length,
            t = Date.now(),
            n = t - this.batchFlushAttemptTimestamp,
            r = e % o.AvoInspector.batchSize == 0,
            s = n >= 1e3 * o.AvoInspector.batchFlushSeconds,
            i = this;

        if (r || s) {
          this.batchFlushAttemptTimestamp = t;
          var a = i.events;
          i.events = [], this.networkCallsHandler.callInspectorWithBatchBody(a, function (e) {
            null != e ? (i.events = i.events.concat(a), o.AvoInspector.shouldLog && console.log("Avo Inspector: batch sending failed: " + e + ". We will attempt to send your schemas with next batch")) : o.AvoInspector.shouldLog && console.log("Avo Inspector: batch sent successfully."), i.saveEvents();
          });
        }
      }, e.prototype.saveEvents = function () {
        if (this.events.length > 1e3) {
          var t = this.events.length - 1e3;
          this.events.splice(0, t);
        }

        o.AvoInspector.avoStorage.setItem(e.cacheKey, this.events);
      }, Object.defineProperty(e, "cacheKey", {
        get: function get() {
          return "AvoInspectorEvents";
        },
        enumerable: !1,
        configurable: !0
      }), e;
    }();

    t.AvoBatcher = r;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AvoNetworkCallsHandler = void 0;

    var o = n(1),
        r = n(4),
        s = n(0),
        i = n(9),
        a = function () {
      function e(e, t, n, o, r) {
        this.samplingRate = 1, this.sending = !1, this.apiKey = e, this.envName = t, this.appName = n, this.appVersion = o, this.libVersion = r;
      }

      return e.prototype.callInspectorWithBatchBody = function (t, n) {
        var o = this;
        if (this.sending) n("Batch sending cancelled because another batch sending is in progress. Your events will be sent with next batch.");else {
          var r = t.filter(function (e) {
            return null != e;
          });
          if (this.fixSessionAndTrackingIds(r), 0 !== r.length) if (Math.random() > this.samplingRate) s.AvoInspector.shouldLog && console.log("Avo Inspector: last event schema dropped due to sampling rate.");else {
            s.AvoInspector.shouldLog && (console.log("Avo Inspector: events", r), r.forEach(function (e) {
              if ("sessionStarted" === e.type) console.log("Avo Inspector: sending session started event.");else if ("event" === e.type) {
                var t = e;
                console.log("Avo Inspector: sending event " + t.eventName + " with schema " + JSON.stringify(t.eventProperties));
              }
            })), this.sending = !0;
            var i = new XMLHttpRequest();
            i.open("POST", e.trackingEndpoint, !0), i.setRequestHeader("Content-Type", "text/plain"), i.send(JSON.stringify(r)), i.onload = function () {
              if (200 != i.status) n("Error " + i.status + ": " + i.statusText);else {
                var e = JSON.parse(i.response).samplingRate;
                void 0 !== e && (o.samplingRate = e), n(null);
              }
            }, i.onerror = function () {
              n("Request failed");
            }, i.ontimeout = function () {
              n("Request timed out");
            }, this.sending = !1;
          }
        }
      }, e.prototype.fixSessionAndTrackingIds = function (e) {
        var t = null,
            n = null;
        e.forEach(function (e) {
          null !== e.sessionId && void 0 !== e.sessionId && "unknown" !== e.sessionId && (t = e.sessionId), null !== e.trackingId && void 0 !== e.trackingId && "unknown" !== e.trackingId && (n = e.trackingId);
        }), e.forEach(function (e) {
          "unknown" === e.sessionId && (e.sessionId = null != t ? t : r.AvoSessionTracker.sessionId), "unknown" === e.trackingId && (e.trackingId = null != n ? n : i.AvoInstallationId.getInstallationId());
        });
      }, e.prototype.bodyForSessionStartedCall = function () {
        var e = this.createBaseCallBody();
        return e.type = "sessionStarted", e;
      }, e.prototype.bodyForEventSchemaCall = function (e, t, n, o) {
        var r = this.createBaseCallBody();
        return r.type = "event", r.eventName = e, r.eventProperties = t, null != n ? (r.avoFunction = !0, r.eventId = n, r.eventHash = o) : (r.avoFunction = !1, r.eventId = null, r.eventHash = null), r;
      }, e.prototype.createBaseCallBody = function () {
        return {
          apiKey: this.apiKey,
          appName: this.appName,
          appVersion: this.appVersion,
          libVersion: this.libVersion,
          env: this.envName,
          libPlatform: "web",
          messageId: o.default.newGuid(),
          trackingId: i.AvoInstallationId.getInstallationId(),
          createdAt: new Date().toISOString(),
          sessionId: r.AvoSessionTracker.sessionId,
          samplingRate: this.samplingRate
        };
      }, e.trackingEndpoint = "https://api.avo.app/inspector/v1/track", e;
    }();

    t.AvoNetworkCallsHandler = a;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AvoInstallationId = void 0;

    var o = n(1),
        r = n(0),
        s = function () {
      function e() {}

      return e.getInstallationId = function () {
        if (null !== e.installationId) return e.installationId;
        if (!r.AvoInspector.avoStorage.isInitialized()) return "unknown";
        var t = r.AvoInspector.avoStorage.getItem(e.cacheKey);
        return null == t ? (e.installationId = o.default.newGuid(), r.AvoInspector.avoStorage.setItem(e.cacheKey, e.installationId)) : e.installationId = t, e.installationId;
      }, Object.defineProperty(e, "cacheKey", {
        get: function get() {
          return "AvoInstallationId";
        },
        enumerable: !1,
        configurable: !0
      }), e.installationId = null, e;
    }();

    t.AvoInstallationId = s;
  }, function (e, t, n) {
    "use strict";

    var _o,
        r = this && this.__extends || (_o = function o(e, t) {
      return (_o = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _o(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    });

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AvoStorage = void 0;

    var s = function () {
      function e() {}

      return e.prototype.parseJson = function (e) {
        return null != e ? JSON.parse(e) : null;
      }, e;
    }(),
        i = (function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.androidMemoryDataToAvoidAsyncQueries = {}, t.AsyncStorage = null, t.memoryStorageInitialized = !1, t.onStorageInitFuncs = [], t.reactNative = null, t.shouldLog = !1, t.suffix = "", t;
      }

      r(t, e), t.prototype.init = function (e, t) {}, t.prototype.loadAndroidDataToMemoryToAvoidAsyncQueries = function (e) {
        var t = this;
        this.AsyncStorage.getAllKeys().then(function (n) {
          return t.AsyncStorage.multiGet(n).then(function (n) {
            t.shouldLog && console.log("Avo Inspector: android loaded data from memory"), n.forEach(function (e) {
              var n = e[0];
              n.endsWith(t.suffix) && (t.androidMemoryDataToAvoidAsyncQueries[n] = e[1], t.shouldLog && console.log(n, e[1]));
            }), e();
          });
        });
      }, t.prototype.initializeStorageAndroid = function () {
        this.memoryStorageInitialized = !0, this.onStorageInitFuncs.forEach(function (e) {
          e();
        });
      }, t.prototype.isInitialized = function () {
        return this.reactNative && this.memoryStorageInitialized;
      }, t.prototype.getItemAsync = function (e) {
        return this.AsyncStorage.getItem(e + this.suffix).then(function (e) {
          return null != e ? JSON.parse(e) : null;
        });
      }, t.prototype.getItem = function (e) {
        var t = this.androidMemoryDataToAvoidAsyncQueries[e + this.suffix];
        return this.parseJson(t);
      }, t.prototype.setItem = function (e, t) {
        this.AsyncStorage.setItem(e + this.suffix, JSON.stringify(t)), this.androidMemoryDataToAvoidAsyncQueries[e + this.suffix] = JSON.stringify(t);
      }, t.prototype.removeItem = function (e) {
        this.AsyncStorage.removeItem(e + this.suffix), this.androidMemoryDataToAvoidAsyncQueries[e + this.suffix] = null;
      }, t.prototype.runAfterInit = function (e) {
        !0 === this.memoryStorageInitialized ? e() : this.onStorageInitFuncs.push(e);
      };
    }(s), function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.reactNative = null, t.suffix = "", t;
      }

      r(t, e), t.prototype.init = function (e, t) {
        0;
      }, t.prototype.isInitialized = function () {
        return null != this.reactNative;
      }, t.prototype.getItemAsync = function (e) {
        var t = this.reactNative.Settings.get(e + this.suffix);
        return Promise.resolve(this.parseJson(t));
      }, t.prototype.getItem = function (e) {
        var t = this.reactNative.Settings.get(e + this.suffix);
        return this.parseJson(t);
      }, t.prototype.setItem = function (e, t) {
        var n;
        this.reactNative.Settings.set(((n = {})[e + this.suffix] = JSON.stringify(t), n));
      }, t.prototype.removeItem = function (e) {
        var t;
        this.reactNative.Settings.set(((t = {})[e + this.suffix] = null, t));
      }, t.prototype.runAfterInit = function (e) {
        e();
      };
    }(s), function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.useFallbackStorage = !1, t.fallbackStorage = {}, t.storageInitialized = !1, t.onStorageInitFuncs = [], t.shouldLog = !1, t.suffix = "", t;
      }

      return r(t, e), t.prototype.init = function (e, t) {
        this.shouldLog = e, this.suffix = t, this.initializeStorageWeb(this.isLocalStorageAvailable());
      }, t.prototype.initializeStorageWeb = function (e) {
        this.storageInitialized = !0, !1 === e && (this.useFallbackStorage = !0), this.onStorageInitFuncs.forEach(function (e) {
          e();
        });
      }, t.prototype.isLocalStorageAvailable = function () {
        var e = new Date().toISOString();

        try {
          return window.localStorage.setItem(e, e), window.localStorage.getItem(e) === e && (window.localStorage.removeItem(e), !0);
        } catch (e) {
          return !1;
        }
      }, t.prototype.isInitialized = function () {
        return this.storageInitialized;
      }, t.prototype.getItemAsync = function (e) {
        var t = this;
        return new Promise(function (n, o) {
          t.runAfterInit(function () {
            if (!0 === t.useFallbackStorage) {
              var o = t.fallbackStorage[e + t.suffix];
              n(t.parseJson(o));
            } else if ("undefined" != typeof window) {
              o = void 0;

              try {
                o = window.localStorage.getItem(e + t.suffix);
              } catch (e) {
                t.shouldLog && console.error("Avo Inspector Storage getItemAsync error:", e), n(null);
              }

              n(t.parseJson(o));
            } else n(null);
          });
        });
      }, t.prototype.getItem = function (e) {
        var t;
        if (!1 === this.storageInitialized) t = null;else if (!0 === this.useFallbackStorage) t = this.fallbackStorage[e + this.suffix];else if ("undefined" != typeof window) try {
          t = window.localStorage.getItem(e + this.suffix);
        } catch (e) {
          this.shouldLog && console.error("Avo Inspector Storage getItem error:", e);
        }
        return this.parseJson(t);
      }, t.prototype.setItem = function (e, t) {
        var n = this;
        this.runAfterInit(function () {
          if (!0 === n.useFallbackStorage) n.fallbackStorage[e + n.suffix] = JSON.stringify(t);else if ("undefined" != typeof window) try {
            window.localStorage.setItem(e + n.suffix, JSON.stringify(t));
          } catch (e) {
            n.shouldLog && console.error("Avo Inspector Storage setItem error:", e);
          }
        });
      }, t.prototype.removeItem = function (e) {
        var t = this;
        this.runAfterInit(function () {
          if (!0 === t.useFallbackStorage) t.fallbackStorage[e + t.suffix] = null;else if ("undefined" != typeof window) try {
            window.localStorage.removeItem(e + t.suffix);
          } catch (e) {
            t.shouldLog && console.error("Avo Inspector Storage removeItem error:", e);
          }
        });
      }, t.prototype.runAfterInit = function (e) {
        !0 === this.storageInitialized ? e() : this.onStorageInitFuncs.push(e);
      }, t;
    }(s)),
        a = function () {
      function e(e, t) {
        void 0 === t && (t = ""), this.Platform = null, this.Platform = "browser", this.storageImpl = new i(), this.storageImpl.init(e, t);
      }

      return e.prototype.isInitialized = function () {
        return this.storageImpl.isInitialized();
      }, e.prototype.getItemAsync = function (e) {
        return this.storageImpl.getItemAsync(e);
      }, e.prototype.getItem = function (e) {
        return this.storageImpl.getItem(e);
      }, e.prototype.setItem = function (e, t) {
        this.storageImpl.setItem(e, t);
      }, e.prototype.removeItem = function (e) {
        this.storageImpl.removeItem(e);
      }, e.prototype.runAfterInit = function (e) {
        this.storageImpl.runAfterInit(e);
      }, e;
    }();

    t.AvoStorage = a;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AvoDeduplicator = void 0;

    var o = n(3),
        r = n(5),
        s = function () {
      function e() {
        this.avoFunctionsEvents = {}, this.manualEvents = {}, this.avoFunctionsEventsParams = {}, this.manualEventsParams = {};
      }

      return e.prototype.shouldRegisterEvent = function (e, t, n) {
        this.clearOldEvents(), n ? (this.avoFunctionsEvents[Date.now()] = e, this.avoFunctionsEventsParams[e] = t) : (this.manualEvents[Date.now()] = e, this.manualEventsParams[e] = t);
        var o = !n;
        return !this.hasSameEventAs(e, t, o);
      }, e.prototype.hasSameEventAs = function (e, t, n) {
        var o = !1;
        return n ? this.lookForEventIn(e, t, this.avoFunctionsEventsParams) && (o = !0) : this.lookForEventIn(e, t, this.manualEventsParams) && (o = !0), o && (delete this.avoFunctionsEventsParams[e], delete this.manualEventsParams[e]), o;
      }, e.prototype.lookForEventIn = function (e, t, n) {
        for (var o in n) {
          if (n.hasOwnProperty(o) && o === e) {
            var s = n[e];
            if (s && r.deepEquals(t, s)) return !0;
          }
        }

        return !1;
      }, e.prototype.hasSeenEventParams = function (e, t) {
        var n = !1;
        return t ? this.lookForEventParamsIn(e, this.avoFunctionsEventsParams) && (n = !0) : this.lookForEventParamsIn(e, this.manualEventsParams) && (n = !0), n;
      }, e.prototype.lookForEventParamsIn = function (e, t) {
        for (var n in t) {
          if (t.hasOwnProperty(n)) {
            var o = t[n];
            if (o && r.deepEquals(e, o)) return !0;
          }
        }

        return !1;
      }, e.prototype.shouldRegisterSchemaFromManually = function (e, t) {
        return this.clearOldEvents(), !this.hasSameShapeInAvoFunctionsAs(e, t);
      }, e.prototype.hasSameShapeInAvoFunctionsAs = function (e, t) {
        var n = !1;
        return this.lookForEventSchemaIn(e, t, this.avoFunctionsEventsParams) && (n = !0), n && delete this.avoFunctionsEventsParams[e], n;
      }, e.prototype.lookForEventSchemaIn = function (e, t, n) {
        for (var s in n) {
          if (n.hasOwnProperty(s) && s === e) {
            var i = o.AvoSchemaParser.extractSchema(n[e]);
            if (i && r.deepEquals(t, i)) return !0;
          }
        }

        return !1;
      }, e.prototype.clearOldEvents = function () {
        var e = Date.now();

        for (var t in this.avoFunctionsEvents) {
          if (this.avoFunctionsEvents.hasOwnProperty(t)) if (e - (Number(t) || 0) > 300) {
            var n = this.avoFunctionsEvents[t];
            delete this.avoFunctionsEvents[t], delete this.avoFunctionsEventsParams[n];
          }
        }

        for (var t in this.manualEvents) {
          if (this.manualEvents.hasOwnProperty(t)) if (e - (Number(t) || 0) > 300) {
            n = this.manualEvents[t];
            delete this.manualEvents[t], delete this.manualEventsParams[n];
          }
        }
      }, e.prototype._clearEvents = function () {
        this.avoFunctionsEvents = {}, this.manualEvents = {}, this.avoFunctionsEventsParams = {}, this.manualEventsParams = {};
      }, e;
    }();

    t.AvoDeduplicator = s;
  }, function (e) {
    e.exports = JSON.parse('{"name":"avo-inspector","version":"1.3.0","description":"","main":"dist/index.js","browser":"dist/index.js","react-native":"dist-native/index.js","types":"dist/index.d.ts","scripts":{"build":"tsc --emitDeclarationOnly && webpack src/index.ts --mode production --resolve-extensions .ts --module-bind ts=ts-loader --define process.env.BROWSER=1 --output-filename index.js --output-library-target umd","build-for-script-tag":"tsc --emitDeclarationOnly && webpack src/browser.js --mode production --resolve-extensions .ts --module-bind ts=ts-loader --define process.env.BROWSER=1 --woutput-filename browser.js --output-library-target umd","build-native":"tsc --outDir dist-native","test":"jest","test:browser":"BROWSER=1 jest","typecheck":"tsc --noEmit"},"repository":{"type":"git","url":"git+https://github.com/avohq/web-avo-inspector.git"},"jest":{"transform":{"^.+\\\\.[j]sx?$":"babel-jest","^.+\\\\.[t]sx?$":"ts-jest"},"testPathIgnorePatterns":["constants","examples","node_modules","dist","dist-native"],"testRegex":"(/__tests__/.*|\\\\.(test|spec))\\\\.(ts|tsx|js)$","moduleFileExtensions":["ts","tsx","js"]},"keywords":["web","analytics","avo","react","react-native","node","javascript"],"author":"Avo (https://www.avo.app)","license":"MIT","bugs":{"url":"https://github.com/avohq/web-avo-inspector/issues"},"homepage":"https://github.com/avohq/web-avo-inspector#readme","devDependencies":{"@babel/core":"7.12.10","@babel/preset-env":"7.12.11","@types/jest":"26.0.19","@types/node":"14.14.16","babel-preset-es2015":"6.24.1","babel-preset-react":"6.24.1","eslint":"7.16.0","eslint-plugin-react":"7.21.5","jest":"26.6.3","prettier":"2.2.1","prettier-eslint":"12.0.0","ts-jest":"26.4.4","ts-loader":"8.0.12","typescript":"4.1.3","webpack":"4.44.2","webpack-cli":"3.3.12"},"externals":["react-native"]}');
  }]);
});